export const AppRoute = {
  ROOT: '/',
  WISHLIST: '/wishlist',
  PROFILE: '/profile',
};
